import _ from 'lodash';
import Wix from './wix-sdk-polyfill';
import { isEditor } from './wix-sdk-utils';
import { updateAppSettings, updateAppSettingsOnStore } from '../actions/update-app-settings';

const EXCLUDED_CSS_FONTS = /fonts\.googleapis/;

export default function listenToSettingsChange(store, isMainPage = false) {
  // TODO: remove when site colors are returned from app settings endpoint
  setTimeout(() => store.dispatch(updateAppSettingsOnStore(getStyleSettings())));

  if (!isEditor()) {
    return;
  }

  Wix.addEventListener(Wix.Events.SITE_SAVED, () => {
    Wix.Styles.getStyleParams(style => {
      store.dispatch(updateAppSettings(Wix.Utils.getCompId(), 'draft', 'editor', getStyleSettings(style), isMainPage));
    });
  });

  Wix.addEventListener(Wix.Events.SITE_PUBLISHED, () => {
    Wix.Styles.getStyleParams(style => {
      Wix.getExternalId(externalId => {
        store.dispatch(
          updateAppSettings(Wix.Utils.getCompId(), externalId || 'published', 'editor', getStyleSettings(style), isMainPage)
        );
      });
    });
  });

  Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, style => {
    store.dispatch(updateAppSettingsOnStore(getStyleSettings(style)));
  });

  Wix.addEventListener(Wix.Events.SETTINGS_UPDATED, data => store.dispatch(data));
}

function getStyleSettings(style = {}) {
  return {
    style: {
      ...style,
      cssUrls: getFontCssUrls(),
    },
    textPresets: Wix.Styles.getSiteTextPresets() || [],
    colorPresets: Wix.Styles.getSiteColors() || [],
  };
}

function getFontCssUrls() {
  return _(document.styleSheets)
    .filter(styleSheet => styleSheet.href)
    .map(styleSheet => styleSheet.href.toLowerCase())
    .map(href => href.replace(/^https?:/, ''))
    .filter(href => !EXCLUDED_CSS_FONTS.test(href))
    .filter(href => href.indexOf('font') >= 0)
    .uniq()
    .value();
}



// WEBPACK FOOTER //
// ./app/services/listen-to-settings-change.js